import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private toastr: ToastrService) { }

  msjError(e: HttpErrorResponse) {
    const message =
      e.error?.msg ||
      e.error?.error ||
      e.message ||
      'Upps ocurrio un error, comuniquese con el administrador';

    if (e.status === 401) {
      this.toastr.error('La sesión expiró o no está autorizada. Inicie sesión nuevamente.', 'Error');
    } else {
      this.toastr.error(message, 'Error');
    }
  }
}
